import I18n from 'components/I18n'
import { actions, selectors } from 'data'
import messages from 'lang'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import styled from 'styled-components'
import { color, redirectToWalletSettings } from 'utils'

const Wrapper = styled.p<{ dark: boolean }>`
  color: ${color('errorMuted')};
  font-weight: 500;
  font-size: 1rem;
  margin-top: 0;

  a {
    color: ${color('primary')};
    text-decoration: none;
    cursor: pointer;
  }
`

const FirstSetup2FA = ({ dark = false, ...rest }) => {
  const config = useSelector(selectors.config.getConfig)
  const user = useSelector(selectors.auth.getUser)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const onSetup2FA = () => {
    if (!user || !config) return
    // Legacy settings change for not unified SSO users
    // We'll clean this up once all users have been merged (SSO phase 4)
    if (!user.unifiedAccountWalletGuid) {
      dispatch(actions.app.showModal('ENABLE_TWO_FACTOR'))
      return
    }

    // New native 2FA flow
    if (config.native2FA) {
      navigate('/settings/2fa')
      return
    }

    // Send to wallet to change settings
    redirectToWalletSettings({
      email: user.email,
      settingsSection: '2fa',
      walletGuid: user.unifiedAccountWalletGuid,
      walletUrl: config.walletUrl
    })
  }

  return (
    <Wrapper dark={dark} {...rest}>
      <I18n
        data={messages.two_factor_required_for_this}
        link={
          <a onClick={onSetup2FA}>
            <I18n data={messages.here} />
          </a>
        }
      />
    </Wrapper>
  )
}

export default FirstSetup2FA
